
import { Component, Vue } from 'vue-property-decorator';
import CameraChildShootingNormal from '@/pages/camera/CameraChildShootingNormal.vue';
import CameraChildShootingFaceAction from '@/pages/camera/CameraChildShootingFaceAction.vue';

@Component({
  components: {
    CameraChildShootingNormal,
    CameraChildShootingFaceAction
  }
})
export default class Page extends Vue {
  private get isFaceAction(): boolean {
    return this.$store.state.camera.shootType === 'face-action';
  }
}
